import React from "react";
import { Box, Typography } from "@mui/material";

interface SectionWrapperProps {
  title: string;
  bgcolor: string;
  children: React.ReactNode;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  title,
  bgcolor,
  children,
}) => (
  <Box sx={{ bgcolor, px: { xs: 2, md: 12 }, py: 6 }}>
    <Typography
      variant="h5"
      fontWeight="bold"
      gutterBottom
      align="center"
      sx={{ color: "#53696d", mb: 2 }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

export default SectionWrapper;
